document.addEventListener("variant:change", function(e) {
  console.log(e.detail);
  var selvalues = e.detail.currentlySelectedValues;
  var btn_addtocart = document.querySelector("button.add-to-cart");
  var op_val = btn_addtocart.getAttribute("data-soldout");

  if(!e.detail.variant.available) {
    if (op_val == 'all') {
      btn_addtocart.querySelector("[data-add-to-cart-text]").textContent = 'Coming Soon';
    }
    else {
      for(var i = 0; i < selvalues.length; i ++) {
        if(op_val == selvalues[i].value) {
          btn_addtocart.querySelector("[data-add-to-cart-text]").textContent = 'Coming Soon';
          break;
        }
      }
    }
  }
});

if (!customElements.get('size-chart')) {
  class SizeChart extends HTMLElement {
    constructor() {
      super();
      
      this.triggerClose = this.querySelector(".btn-close");
      
      this.init();
    }

    openSizeChart() {
      this.classList.add("opened");
    }

    closeSizeChart() {
      this.classList.remove("opened");
    }
    
    init() {
      let sizechart = this;
      const _this = this;

      //Filter country
      let url = window.location.href;
      if(url.includes("/fr")) {
        sizechart.querySelector(".sizechart_body").classList.add("show_fr");
        document.querySelector("body").classList.add("show_fr");
      }

      this.triggerClose.addEventListener("click", function(e) {
        sizechart.closeSizeChart();
      });

      this.querySelectorAll(".unit-switch").forEach(function(obj) {
        obj.addEventListener("click", function(e) {
          console.log("unit-switch clicked");
          obj.parentElement.querySelectorAll(".unit-switch").forEach(function(obj1) {
            obj1.classList.remove("active");
          });

          obj.classList.add("active");
          if (obj.classList.contains("show_cm")) {
            _this.querySelector(".sizechart_table").classList.add("unit_cm");
          }
          else {
            _this.querySelector(".sizechart_table").classList.remove("unit_cm");
          }
        });
      });

      this.addEventListener("click", function(e) {
        console.log(e);

        if(e.target.classList.contains('opened')) {
          _this.classList.remove("opened");
        }
      });
    }
  }

  customElements.define('size-chart', SizeChart);
}
      
document.querySelectorAll(".trigger-sizechart").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    var sizechart_id = obj.getAttribute("href");
    document.querySelector(sizechart_id).openSizeChart();
  });
});
      
document.querySelectorAll(".trigger-sizechart-fr").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    var sizechart_id = obj.getAttribute("href");
    document.querySelector(sizechart_id).openSizeChart();
  });
});

document.querySelectorAll(".unit-switch").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    console.log("unit-switch clicked");
    obj.parentElement.querySelectorAll(".unit-switch").forEach(function(obj1) {
      obj1.classList.remove("active");
    });

    obj.classList.add("active");
    if (obj.classList.contains("show_cm")) {
      document.querySelector(".sizechart_table").classList.add("unit_cm");
    }
    else {
      document.querySelector(".sizechart_table").classList.remove("unit_cm");
    }
  });
});

document.querySelectorAll(".grid-product .grid-product__swatches-wrapper .color-swatch").forEach(function(obj) {	
  obj.addEventListener("mouseover", function(e) {	
    var card = this.closest(".grid-product__content");	
    var soldout_tag = card.querySelector(".grid-product__tag--sold-out");	
  	
    if(this.classList.contains("soldout")) {	
      card.classList.add("soldout");	
      if(soldout_tag) {	
        // soldout_tag.classList.remove("hide");	
      }	
    }	
    else {	
      card.classList.remove("soldout");	
      if(soldout_tag) {	
        // soldout_tag.classList.add("hide");	
      }	
    }	
  });	
});